import axios from 'axios'
import apiKioskClient, { refreshKioskSession, clearKioskSession } from '../clients/ApiKioskClient'

const buildErrorMessage = (error) => {
    let errorMessage = 'Unexpected error occurred'

    if (axios.isAxiosError(error)) {
        if (error.response) {
            errorMessage = error.response.data?.message || 'Unexpected error occurred.'
        } else if (error.message.includes('ERR_CONNECTION_REFUSED')) {
            errorMessage = 'Connection refused. Please check the backend server.'
        }
        console.error('Axios error:', error.response?.status, error.response?.data)
    } else {
        console.error('Unexpected error:', error)
        errorMessage = 'An unexpected error occurred: ' + error.message
    }

    return errorMessage
}

export const kioskLogin = async ({ kioskCode, secret }) => {
    try {
        const response = await apiKioskClient.post('/kiosk/auth/login', { kioskCode, secret })
        // Confirmed live: { access_token, refresh_token, kiosk } — snake_case tokens,
        // same convention as the staff AuthService.login, unlike admin kiosk endpoints.
        localStorage.setItem('kioskAccessToken', response.data.access_token)
        localStorage.setItem('kioskRefreshToken', response.data.refresh_token)
        return response.data
    } catch (error) {
        return { error: buildErrorMessage(error) }
    }
}

// Refresh tokens are single-use and rotate on every call — refreshKioskSession()
// (shared with the response interceptor in ApiKioskClient.js) always persists the
// new refresh token it receives, never reuses the old one.
export const kioskRefresh = async () => {
    try {
        const accessToken = await refreshKioskSession()
        return { accessToken }
    } catch (error) {
        return { error: buildErrorMessage(error) }
    }
}

export const kioskLogout = async () => {
    try {
        const response = await apiKioskClient.post('/kiosk/auth/logout')
        return response.data
    } catch (error) {
        return { error: buildErrorMessage(error) }
    } finally {
        clearKioskSession()
    }
}

export const getKioskIdentity = async () => {
    try {
        const response = await apiKioskClient.get('/kiosk/me')
        return response.data
    } catch (error) {
        return { error: buildErrorMessage(error) }
    }
}

export const sendKioskHeartbeat = async () => {
    try {
        const response = await apiKioskClient.post('/kiosk/heartbeat')
        return response.data
    } catch (error) {
        return { error: buildErrorMessage(error) }
    }
}
